import './OutOfZoneNotice.less';

/**
 * Хаяг хүргэлтийн бүсэд байгаа эсэхийг харуулна. Зөвхөн мэдээлэл — захиалга үүсгэхийг
 * зогсоохгүй, алдаа гарвал (эсвэл шалгах өгөгдөл дутуу бол) юу ч харуулахгүй.
 */
const OutOfZoneNotice = ({ loading, data }) => {
  if (loading) {
    return (
      <span className="zone-status-badge zone-status-checking">
        <span className="zone-status-dot" />
        Бүс шалгаж байна…
      </span>
    );
  }

  if (!data) return null;

  if (!data.isOutOfZone) {
    return (
      <span className="zone-status-badge zone-status-inzone">
        <span className="zone-status-dot" />
        Хүргэлтийн бүсэд байна
      </span>
    );
  }

  return (
    <span className="zone-status-badge zone-status-outzone">
      <span className="zone-status-dot" />
      Бүсээс {data.distanceKm} км хэтэрсэн
      {data.zoneName && (
        <span className="zone-status-hint">(хамгийн ойр бүс: {data.zoneName})</span>
      )}
    </span>
  );
};

export default OutOfZoneNotice;
